var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex min-h-screen items-center",staticStyle:{"background":"#f0f2f5"}},[_c('div',{staticClass:"w-full"},[_c('b-row',[_c('b-col',{staticClass:"mx-auto",attrs:{"cols":"6"}},[_c('router-view')],1)],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }